module.exports = __webpack_public_path__ + "dataLink.c796c798.jpg";